<button matButton="filled" (click)="addToCart($event)">
    <div class="btn-content">
        <i class="fa-regular fa-cart-plus"></i>
    </div>
</button>
